module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-Hant":{"publish":"發佈","discard":"捨棄","unpublishedChanges":"尚未發佈的變更"},"en":{"publish":"Publish","discard":"Discard","unpublishedChanges":"unpublished changes"}}')
  delete Component.options._Ctor
}
